export const isMagnoliaEditingMode = (): boolean =>
  window.ui?.cmsState?.mode === 'editing';
export const setMagnoliaEditingMode = (mode) => {
  window.ui.cmsState.mode = mode;
};

export const getDocumentHeight = () => {
  const { body } = document;

  const html = document.documentElement;

  return Math.max(
    body.scrollHeight,
    body.offsetHeight,
    html.clientHeight,
    html.scrollHeight,
    html.offsetHeight
  );
};
